import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getStudentSubjects } from "../../redux/slices/subjectsSlice";
import { getSubjectLessons, getTeacherClasses, getTeacherClassLessons, getParentChildren, getChildLessons, getChildSubjects } from "../../redux/slices/lessonsSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./ParentChildLessons.css";
import { useDarkMode } from "../../contexts/DarkModeContext";

function ParentChildLessons() {
    const dispatch = useDispatch();
    const { isDarkMode } = useDarkMode();
    const { studentSubjects, subjectsLoading } = useSelector((state) => state.subjects);
    const { 
        subjectLessons, 
        teacherClasses, 
        teacherClassLessons, 
        lessonsLoading, 
        lessonsPagination,
        parentChildren,
        parentChildrenLoading,
        childLessons,
        childLessonsLoading,
        childSubjects,
        childSubjectsLoading
    } = useSelector((state) => state.lessons);
    const { currentUser } = useSelector((state) => state.auth);
    
    const [activeTab, setActiveTab] = useState(0); // 0 = الكل افتراضياً
    const [currentPage, setCurrentPage] = useState(1);
    const [isGuestMode, setIsGuestMode] = useState(true);
    const [selectedChild, setSelectedChild] = useState(null);
    const [selectedSubjectId, setSelectedSubjectId] = useState(0); // 0 = الكل افتراضياً

    const userRole = currentUser?.role || localStorage.getItem("userRole");
    const isTeacher = userRole === "teacher";
    const isParent = userRole === "parent";

    // الحصص المجانية الثابتة للـ Guest Mode
    const staticLessons = [
        { id: 1, name: "اسم الحصة الدراسية", teacher: "احمد ابراهيم", subject: "علوم", students: "50+", files: 4, videos: 1, rating: 5, reviews: 21, image: "/science.png" },
        { id: 2, name: "الكيمياء للصف الأول", teacher: "محمد علي", subject: "كيمياء", students: "35+", files: 3, videos: 2, rating: 4, reviews: 15, image: "/courseimage.png" },
        { id: 3, name: "الرياضيات المتقدمة", teacher: "سعيد محمود", subject: "رياضيات", students: "60+", files: 5, videos: 3, rating: 5, reviews: 40, image: "/math.png" },
        { id: 4, name: "الأحياء التطبيقي", teacher: "ليلى حسن", subject: "أحياء", students: "45+", files: 4, videos: 2, rating: 5, reviews: 25, image: "/science.png" },
        { id: 5, name: "فيزياء القوى", teacher: "عمر خالد", subject: "فيزياء", students: "55+", files: 3, videos: 2, rating: 4, reviews: 18, image: "/physic.png" },
    ];

    // التحقق من وجود token عند تحميل المكون
    useEffect(() => {
        const token = localStorage.getItem("token3almny");
        if (token) {
            setIsGuestMode(false);
            if (isParent) {
                dispatch(getParentChildren());
            } else if (isTeacher) {
                dispatch(getTeacherClasses());
            } else {
                dispatch(getStudentSubjects());
            }
        } else {
            setIsGuestMode(true);
        }
    }, [dispatch, isTeacher, isParent]);

    // جلب مواد الابن عند تغيير الابن المختار
    useEffect(() => {
        console.log("🔍 === useEffect getChildSubjects ===");
        console.log("🔍 selectedChild:", selectedChild);
        console.log("🔍 selectedChild?.id:", selectedChild?.id);
        
        if (selectedChild) {
            console.log("🔍 جلب مواد الابن:", selectedChild.id);
            console.log("🔍 dispatch(getChildSubjects):", selectedChild.id);
            dispatch(getChildSubjects(selectedChild.id));
        } else {
            console.log("🔍 لا يوجد ابن مختار");
        }
        console.log("🔍 === END useEffect getChildSubjects ===");
    }, [selectedChild, dispatch]);

    // جلب دروس الابن عند تغيير الابن أو المادة
    useEffect(() => {
        console.log("🔍 === useEffect getChildLessons ===");
        console.log("🔍 selectedChild:", selectedChild);
        console.log("🔍 selectedSubjectId:", selectedSubjectId);
        
        if (selectedChild) {
            console.log("🔍 جلب دروس الابن:", selectedChild.id, "المادة:", selectedSubjectId);
            console.log("🔍 dispatch(getChildLessons):", { childId: selectedChild.id, subjectId: selectedSubjectId });
            dispatch(getChildLessons({ childId: selectedChild.id, subjectId: selectedSubjectId }));
        } else {
            console.log("🔍 لا يوجد ابن مختار لجلب الدروس");
        }
        console.log("🔍 === END useEffect getChildLessons ===");
    }, [selectedChild, selectedSubjectId, dispatch]);

    // تحديث selectedChild عند تغيير parentChildren
    useEffect(() => {
        if (parentChildren.length > 0 && !selectedChild) {
            const firstChild = parentChildren[0];
            setSelectedChild(firstChild);
            // جلب مواد ودروس الابن الأول مباشرة
            if (firstChild) {
                console.log("تعيين الابن الأول وجلب مواده ودروسه:", firstChild.id);
                dispatch(getChildSubjects(firstChild.id));
                dispatch(getChildLessons({ childId: firstChild.id, subjectId: 0 }));
            }
        }
    }, [parentChildren, selectedChild, dispatch]);

    // Debug: طباعة البيانات
    useEffect(() => {
        console.log("🔍 === DEBUG DATA ===");
        console.log("🔍 parentChildren:", parentChildren);
        console.log("🔍 selectedChild:", selectedChild);
        console.log("🔍 childSubjects:", childSubjects);
        console.log("🔍 childSubjectsLoading:", childSubjectsLoading);
        console.log("🔍 childLessons:", childLessons);
        console.log("🔍 childLessonsLoading:", childLessonsLoading);
        console.log("🔍 === END DEBUG ===");
    }, [parentChildren, selectedChild, childSubjects, childLessons, childSubjectsLoading, childLessonsLoading]);

    // دالة تغيير المادة
    const handleSubjectChange = (subjectId) => {
        setSelectedSubjectId(subjectId);
        setActiveTab(subjectId === 0 ? 0 : subjectId);
    };

    // جلب الدروس عند تغيير المادة النشطة (فقط في Authenticated Mode)
    useEffect(() => {
        if (!isGuestMode && !isParent) {
            if (isTeacher) {
                // للمعلمين: جلب دروس الفصل المحدد
                if (teacherClasses.length > 0) {
                    const selectedClass = teacherClasses[activeTab];
                    if (selectedClass?.id) {
                        console.log("جلب دروس الفصل:", selectedClass.id);
                        dispatch(getTeacherClassLessons({ 
                            classId: selectedClass.id, 
                            page: currentPage
                        }));
                    }
                }
            } else {
                // للطلاب: جلب دروس المادة المحددة
                if (studentSubjects.length > 0) {
                    const selectedSubject = studentSubjects[activeTab - 1];
                    const subjectId = activeTab === 0 ? 0 : selectedSubject?.id;
                    if (subjectId !== undefined) {
                        dispatch(getSubjectLessons({
                            subjectId: subjectId,
                            page: currentPage
                        }));
                    }
                }
            }
        }
    }, [activeTab, currentPage, studentSubjects, teacherClasses, dispatch, isGuestMode, isTeacher, isParent]);

    // Mapping للأيقونات حسب اسم المادة أو الفصل
    const getSubjectIcon = (title) => {
        const iconMap = {
            "الرياضيات": "/math.png",
            "الدراسات الاجتماعية": "/drasat.png",
            "اللغة العربية": "/arabic.png",
            "العلوم": "/science.png",
            "جغرافيا": "/gohraphia.png",
            "فيزياء": "/physic.png",
            "اللغة الإنجليزية": "/english.png",
            "تاريخ": "/tarekh.png",
            "اللغة الانجليزية": "/english.png",
        };
        return iconMap[title] || "/science.png";
    };

    // تحويل الدروس إلى الشكل المطلوب للعرض
    const formatLessons = (lessons, subjectName) => {
        // التأكد من أن lessons مصفوفة
        if (!Array.isArray(lessons)) {
            console.warn("formatLessons: lessons is not an array:", lessons);
            return [];
        }
        
        return lessons.map((lesson) => ({
            id: lesson.id,
            name: lesson.title,
            teacher: lesson.user_name || "معلم",
            subject: (lesson.subject_name || subjectName || "").replace(/[\n\r]+/g, " ").trim(),
            students: "50+",
            files: 4,
            videos: 1,
            rating: lesson.rate || 0,
            reviews: lesson.love || 0,
            image: lesson.image,
            day: lesson.day,
            time: lesson.time,
            video_type: lesson.video_type
        }));
    };

    const handleTabClick = (index) => {
        console.log("تم الضغط على tab:", index);
        setActiveTab(index);
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    // تحديد البيانات التي سيتم عرضها
    let tabsData = [];
    let lessonsToShow = staticLessons;

    if (!isGuestMode) {
        if (isParent) {
            // لولي الأمر: عرض دروس الابن المختار
            tabsData = childSubjects || [];
            lessonsToShow = formatLessons(childLessons, "");
        } else if (isTeacher) {
            tabsData = teacherClasses;
            lessonsToShow = formatLessons(teacherClassLessons?.data || [], "");
            console.log("دروس المعلم:", teacherClassLessons);
        } else {
            tabsData = Array.isArray(studentSubjects) ? studentSubjects : [];
            lessonsToShow = formatLessons(subjectLessons || [], Array.isArray(studentSubjects) ? studentSubjects[activeTab - 1]?.title : "");
        }
    }
    
    const token = localStorage.getItem('token3almny');

    return (
        <section className={`all-lessons-page ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <div className="animated-background">
                <div className="floating-elements">
                    <div className="floating-element element-1">📚</div>
                    <div className="floating-element element-2">🔬</div>
                    <div className="floating-element element-3">🧮</div>
                    <div className="floating-element element-4">⚗️</div>
                    <div className="floating-element element-5">🌍</div>
                    <div className="floating-element element-6">🔭</div>
                    <div className="floating-element element-7">📐</div>
                    <div className="floating-element element-8">🧪</div>
                </div>
            </div>
            <div className="container">
                <div className="parent-child-lessons">
                <div className="lessons-breadcrumb">
          <h1 className="breadcrumb-title">دروس الأبناء</h1>
          <div className="breadcrumb-links2">
            <span className="breadcrumb-link">الرئيسية</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">دروس الأبناء</span>
          </div>
        </div>

                    {/* Dropdown لاختيار الابن لولي الأمر */}
                    {isParent && !isGuestMode && (
                        <div className="child-selector mb-4">
                            <label htmlFor="childSelect" className="form-label fw-bold text-primary mb-2">
                                اختر الابن:
                            </label>
                            <select
                                id="childSelect"
                                className="form-select"
                                value={selectedChild?.id || ""}
                                onChange={(e) => {
                                    console.log("تم تغيير الابن إلى:", e.target.value);
                                    const child = parentChildren.find(c => c.id == e.target.value);
                                    console.log("الابن المختار:", child);
                                    setSelectedChild(child);
                                    // إعادة تعيين المادة إلى الكل عند تغيير الابن
                                    setSelectedSubjectId(0);
                                }}
                                disabled={parentChildrenLoading}
                            >
                                {parentChildrenLoading ? (
                                    <option>جاري التحميل...</option>
                                ) : parentChildren.length > 0 ? (
                                    parentChildren.map(child => (
                                        <option key={child.id} value={child.id}>
                                            {child.name}
                                        </option>
                                    ))
                                ) : (
                                    <option>لا يوجد أبناء</option>
                                )}
                            </select>
                        </div>
                    )}

                    {/* Tabs المواد لولي الأمر */}
                    {isParent && !isGuestMode && selectedChild && (
                        <div className="subjects-tabs mb-4">
                            {console.log("🔍 عرض المواد - childSubjects:", childSubjects)}
                            {console.log("🔍 عرض المواد - childSubjects.length:", childSubjects?.length)}
                            {console.log("🔍 عرض المواد - selectedChild:", selectedChild)}
                            
                            {/* خيار الكل - يظهر دائماً */}
                            <button
                                className={`subject-tab ${selectedSubjectId === 0 ? 'active' : ''}`}
                                onClick={() => handleSubjectChange(0)}
                            >
                                <img 
                                    src="/science.png" 
                                    alt="الكل" 
                                    className="tab-icon" 
                                />
                                <span>الكل</span>
                            </button>
                            
                                                                    {/* باقي المواد - تظهر فقط إذا وجدت */}
                            {childSubjects?.data && childSubjects.data.length > 0 && 
                                childSubjects.data.map((subject) => (
                                    <button
                                        key={subject.id}
                                        className={`subject-tab ${selectedSubjectId === subject.id ? 'active' : ''}`}
                                        onClick={() => handleSubjectChange(subject.id)}
                                    >
                                        <img 
                                            src="/science.png" 
                                            alt={subject.title} 
                                            className="tab-icon" 
                                        />
                                        <span>{subject.title}</span>
                                    </button>
                                ))
                            }
                        </div>
                    )}

                    {/* عرض loading إذا كانت البيانات قيد التحميل */}
                    {!isGuestMode && (lessonsLoading || childLessonsLoading) ? (
                        <div className="loading-container">
                            <div className="loading-spinner">
                                {isParent ? "جاري تحميل دروس الابن..." : "جاري تحميل الدروس..."}
                            </div>
                        </div>
                    ) : lessonsToShow.length === 0 ? (
                        <div className="no-lessons-container">
                            <div className="no-lessons-message">
                                <div className="no-lessons-icon">📚</div>
                                <h4>لا توجد حصص دراسية</h4>
                                <p>
                                    {isParent 
                                        ? "لا توجد حصص دراسية متاحة للابن المختار حالياً"
                                        : "لا توجد حصص دراسية متاحة حالياً"
                                    }
                                </p>
                            </div>
                        </div>
                    ) : (
                        <>
                            <Swiper
                                modules={[Pagination, Autoplay]}
                                spaceBetween={20}
                                slidesPerView={1}
                                pagination={{
                                    clickable: true,
                                    dynamicBullets: true,
                                    renderBullet: function (index, className) {
                                        return '<span class="' + className + ' custom-pagination-bullet"></span>';
                                    },
                                }}
                                autoplay={{ delay: 4000, disableOnInteraction: false }}
                                loop={true}
                                className="lessons-swiper mt-3"
                                breakpoints={{
                                    576: {
                                        slidesPerView: 2,
                                        spaceBetween: 15,
                                    },
                                    768: {
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                    },
                                    992: {
                                        slidesPerView: 4,
                                        spaceBetween: 20,
                                    },
                                    1200: {
                                        slidesPerView: 4,
                                        spaceBetween: 25,
                                    },
                                }}
                            >
                                {Array.isArray(lessonsToShow) && lessonsToShow.map((lesson) => (
                                    <SwiperSlide key={lesson.id}>
                                        <Link 
                                            to={`/lessonDetails/${lesson.id}`}
                                            className="lesson-card shadow-sm text-decoration-none"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {/* Header */}
                                            <div
                                                className="lesson-header"
                                                style={{
                                                    backgroundImage: !token 
                                                        ? `url('/courseimage.png')`
                                                        : lesson.image
                                                            ? `url(${lesson.image})`
                                                            : `url('/courseimage.png')`,
                                                    height: "200px"
                                                }}
                                            >
                                            </div>

                                            {/* Body */}
                                            <div className="lesson-body">
                                                <div className="rating">
                                                    <span className="reviews">({lesson.reviews})</span>
                                                    <span className="stars">{"★".repeat(lesson.rating)}</span>
                                                </div>
                                                <h5 className="lesson-name" style={{fontSize : '12px', lineHeight : '2.1'}}>{lesson.name}</h5>
                                                <div className="lesson-info">
                                                    <span style={{ fontSize: "12px" }}>👥 {lesson.students} طالب</span>
                                                    <span style={{ fontSize: "12px" }}>📄 {lesson.files} ملفات</span>
                                                    <span style={{ fontSize: "12px" }}>🎥 فيديو شرح</span>
                                                </div>
                                            </div>

                                            {/* Footer */}
                                            <div className="lesson-footer align-items-center mb-2">
                                                <div className="teacher">
                                                    <img src="/user.png" alt="3almny Academy" className="teacher-img " />
                                                    <span style={{ fontSize: "13px" }} className="teacher mx-1">{lesson.teacher}</span>
                                                </div>
                                                {lesson.subject && lesson.subject.trim() !== "" && (
                                                    <span style={{ fontSize: "9px" }} className="subject mt-3">{lesson.subject}</span>
                                                )}
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>

                            {/* Pagination */}
                            {!isGuestMode && !isParent && lessonsPagination && lessonsPagination.pages_count >= 1 && (
                                <div className="pagination-container">
                                    <div className="pagination">
                                        {Array.from({ length: lessonsPagination.pages_count || 0 }, (_, i) => i + 1).map((page) => (
                                            <button
                                                key={page}
                                                className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </section>
    );
}

export default ParentChildLessons;
